import dynamic from 'next/dynamic'

export const DynamicGlobalAddressModal = dynamic(
  () => import('.').then((mod) => mod.GlobalAddressModal),
  { ssr: false },
)
